import { useState, useEffect } from 'react';
export var ScriptStatus;
(function (ScriptStatus) {
    ScriptStatus[ScriptStatus["IDLE"] = 0] = "IDLE";
    ScriptStatus[ScriptStatus["LOADING"] = 1] = "LOADING";
    ScriptStatus[ScriptStatus["READY"] = 2] = "READY";
    ScriptStatus[ScriptStatus["ERROR"] = 3] = "ERROR";
})(ScriptStatus || (ScriptStatus = {}));
export default function useScript(src) {
    const [status, setStatus] = useState(src ? ScriptStatus.LOADING : ScriptStatus.IDLE);
    const stringStatusToEnum = (status) => {
        if (status) {
            switch (status) {
                case 'idle':
                    return ScriptStatus.IDLE;
                case 'loading':
                    return ScriptStatus.LOADING;
                case 'ready':
                    return ScriptStatus.READY;
                case 'error':
                    return ScriptStatus.ERROR;
                default:
                    return ScriptStatus.IDLE;
            }
        }
        else {
            return null;
        }
    };
    useEffect(() => {
        if (!src) {
            setStatus(ScriptStatus.IDLE);
            return;
        }
        let script = document.querySelector(`script[src="${src}"]`);
        if (!script) {
            // Create script
            script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.setAttribute('data-status', 'loading');
            document.body.appendChild(script);
            const setAttributeFromEvent = (event) => {
                script &&
                    script.setAttribute('data-status', event.type === 'load' ? 'ready' : 'error');
            };
            script.addEventListener('load', setAttributeFromEvent);
            script.addEventListener('error', setAttributeFromEvent);
        }
        else {
            setStatus(stringStatusToEnum(script.getAttribute('data-status')) ||
                ScriptStatus.IDLE);
        }
        const setStateFromEvent = (event) => {
            setStatus(event.type === 'load' ? ScriptStatus.READY : ScriptStatus.ERROR);
        };
        script.addEventListener('load', setStateFromEvent);
        script.addEventListener('error', setStateFromEvent);
        return () => {
            if (script) {
                script.removeEventListener('load', setStateFromEvent);
                script.removeEventListener('error', setStateFromEvent);
            }
        };
    }, [src]);
    return status;
}
//# sourceMappingURL=useScript.js.map